import * as React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";

export default function CircularIndeterminate() {
  return (
    <div style={{
      position: "fixed",
      top: 0,
      width: "100%",
      height: "100%",
      zIndex: "999",
      backgroundColor: "rgba(0,0,0,0.4)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    }}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          width: "200px",
          height: "175px",
          backgroundColor: "white",
          boxShadow: " rgba(0, 0, 0, 0.35) 0px 5px 15px",
          // boxShadow: " #f26639",
          borderRadius: "3px",
          zIndex: 999,
          position: "absolute",
          // top: "37%",left:"42%"
          // top: "50vh",
          // left: "50vw",
        }}
      >
        <div>
          <p style={{ margin: 10, textAlign: "center", fontSize: "12px" }}>
            Loading...
          </p>
        </div>
        <CircularProgress
          sx={{
            width: "87px !important",
            height: "87px !important",
            margin: "auto",
            color: "#f26639",
          }}
        // color="#f26639"
        />
      </Box>
    </div>
  );
}
